import { CompanyConfigurations } from "../Model/businessObjects";
import { COMPANY_CONFIGURATIONS } from "../Reducers/companyConfigurtionsReducer";
import { fetchCompanyConfigurations } from "../Util/queries";

export const getCompanyConfigurations = () => async (dispatch) => {
    try {
        const response = await fetchCompanyConfigurations();
        dispatch({
            type: COMPANY_CONFIGURATIONS,
            payload: new CompanyConfigurations(response.data.configurations)
        });

    } catch (error) {
        console.error(error);
        dispatch({
            type: COMPANY_CONFIGURATIONS,
            payload: new CompanyConfigurations({})
        });
    }
}